import React from 'react';

const ChristmasDecorations = () => (
  <div className="fixed inset-0 pointer-events-none overflow-hidden z-40" aria-hidden="true">
    {Array.from({ length: 6 }, (_, index) => (
      <span className="christmas-snowflake" key={index}>
        ❄
      </span>
    ))}
  </div>
);

export default ChristmasDecorations;
